import {alpha, Theme} from "@mui/material";
import {Colors} from "../../colors";

// ----------------------------------------------------------------------

export default function Drawer(theme: Theme) {
  const isLight = theme.palette.mode === "light";

  return {
    MuiDrawer: {
      styleOverrides: {
        modal: {
          '&[role="presentation"]': {
            "& .MuiDrawer-paperAnchorLeft": {
              boxShadow: `8px 24px 24px 12px ${alpha(Colors.grey._1000, isLight ? 0.16 : 0.48)}`,
            },
            "& .MuiDrawer-paperAnchorRight": {
              boxShadow: `-8px 24px 24px 12px ${alpha(Colors.grey._1000, isLight ? 0.16 : 0.48)}`,
            },
          },
        },
      },
    },
  };
}
